import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class DeviceDataClassificationsService {

  static listAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}devices/dataclassifications`).then((data) => {
        resolve({ deviceDataClassifications: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default DeviceDataClassificationsService;
